import React from 'react';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import {calendarDate} from 'shared/tools';

const errorMessages = (fieldType, translateErrors, errors) => {
  switch (fieldType) {
    case 'missingFields':
      return errors.map(e => t(`nmbr.errors.missing_fields.${e}`)).join(', ');
    default:
      return translateErrors ? errors.map(e => t(`nmbr.errors.messages.${e}`)).join(' ') : errors.join(' ');
  }
};

const EmployeeErrors = ({nmbrEmployee}) => {
  return Object.entries(nmbrEmployee.errorsFromLastSync).map(([fieldType, errors]) => <div key={fieldType}>
    <div className='medium'>
      <FormattedMessage id={`nmbr.employees.directory.sync_error_headers.${fieldType}`}/>
    </div>
    <ul className='ml2'>
      {errors.map(error => <li>
        {t(`nmbr.employees.directory.sync_errors.${fieldType}`, {
          effectiveDate: calendarDate(error.effectiveDate),
          recordType: t(`nmbr.errors.record_types.${error.recordType}`),
          errors: errorMessages(fieldType, error.translateErrors, error.errors)
        })}
      </li>)}
    </ul>
  </div>);
};

export default EmployeeErrors;
